import React from 'react';
import { Box, Typography, Tooltip, Grid2 } from '@mui/material';
import UploadCloudIcon from '@mui/icons-material/CloudUpload';
import DescriptionIcon from '@mui/icons-material/Description';

const FileUpload = (props) => {
  const {
    title,
    uniqueId,
    required = false,
    acceptedFormats = '.pdf, .doc, .docx',
    files = [],
    filePath = null,
    handleDrop,
    handleDragOver,
    handleFileChange,
    handleDownload,
    disabled
  } = props;

  // Extract file extension from filePath
  const fileExtension = filePath?.split('.').pop();

  return (
    <Grid2 sx={{ width: '100%' }}>
      <Typography sx={{ fontSize: '14px', color: '#414651' }}>
        {title}
        {required && <span style={{ color: 'red' }}> *</span>}
      </Typography>
      <Grid2 item sx={{ flexGrow: 1 }}>
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <div
            style={{ border: '1px solid #E9EAEB', height: '130px', width: '100%', borderRadius: '10px' }}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
          >
            <input
              type="file"
              id={uniqueId}
              style={{ marginBottom: '15px', display: 'none' }}
              onChange={handleFileChange}
              accept={acceptedFormats}
              multiple={false}
              disabled={disabled ? true : false}
            />
            <label
              htmlFor={uniqueId}
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
              }}
            >
              <div
                style={{
                  height: '45px',
                  width: '43px',
                  borderRadius: '10px',
                  border: '1px solid #E9EAEB',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: '10px',
                }}
              >
                <UploadCloudIcon />
              </div>
              <Typography sx={{ color: '#535862', fontSize: '14px' }}>
                <span style={{ color: '#6941C6', fontWeight: 600, fontSize: '14px' }}>Click to Upload</span> or drag and drop
              </Typography>
              <Typography sx={{ color: '#535862', fontSize: '14px', marginTop: '4px' }}>PDF, DOC, DOCX</Typography>
            </label>
          </div>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {Array.isArray(files) && files.length > 0 && (
              <DescriptionIcon
                sx={{ color: files[files.length - 1]?.name?.endsWith('pdf') ? '#F40009' : '#0039a6' }}
              />
            )}
            <Typography sx={{ fontSize: '14px', color: '#535862' }}>
              {Array.isArray(files) && files.length > 0 ? files[files.length - 1]?.name : ''}
            </Typography>

          </Box>
          <Box sx={{ width: '100%', alignItems: 'center', display: 'flex' }}>
            {filePath !== null && files?.length === 0 && (
              <DescriptionIcon sx={{ color: fileExtension === 'pdf' ? '#F40009' : '#0039a6' }} />
            )}
            <span
              onClick={handleDownload}
              style={{ fontSize: '14px', color: '#6941C6', textDecoration: 'none', marginTop: '3px', cursor: 'pointer' }}
            >
              <Tooltip
                slotProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: '#0A0D12',
                      borderRadius: '8px',
                      padding: '8px 12px',
                      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                    },
                  },
                }}
                title={fileExtension === 'pdf' ? 'Click to Open' : 'Click to Download'}
              >
                {files?.length === 0 && filePath?.substring(filePath.lastIndexOf('/') + 1)}
              </Tooltip>
            </span>
          </Box>
        </div>
      </Grid2>
    </Grid2>
  );
};


export default FileUpload;
